<ng-container *ngIf="to['open'] && !formState['readonly'] && !to['readonly']; else card">
  <div class="p-col-12 p-2" *ngIf="to['hintKind']">
    <tpa-hint-fill-button kind="address" [ownerId]="ownerId" (pick)="fillFromHint($any($event))"></tpa-hint-fill-button>
  </div>
  <formly-field *ngFor="let field of field.fieldGroup" [field]="field"></formly-field>
</ng-container>
<ng-template #card>
  <div class="tpa-wrapper__content">
    <div *ngIf="emptyModel; else notEmpty">
      <p>
        {{ 'TPA.NotFilled' | transloco }}
      </p>
    </div>
    <ng-template #notEmpty>
      <div *ngIf="!props['sameAsAnotherAddress'] && !emptyModel">
        <p>
          {{ field.formControl?.value?.ulice }}
          {{ field.formControl?.value?.popCislo }}
          <span *ngIf="field.formControl?.value?.orCislo"> / {{ field.formControl?.value?.orCislo }} </span>
        </p>
        <p>{{ model?.mesto }}
          <span *ngIf="field.formControl?.value?.psc">, {{ field.formControl?.value?.psc}}</span>
        </p>
      </div>
      <div *ngIf="!emptyModel && props?.['sameAsAnotherAddress']">
        <p>
          {{ to['actionText'] }}
        </p>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #same> </ng-template>